module.exports = {"622925100":"城关镇","622925101":"三合镇","622925102":"三十里铺镇","622925103":"马家堡镇","622925104":"买家集镇","622925105":"松鸣镇","622925106":"陈家集镇","622925107":"罗家集镇","622925108":"新营镇","622925200":"梁家寺乡","622925203":"卜家庄乡","622925205":"新庄乡","622925207":"达浪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/622925.json
// module id = 2968
// module chunks = 0